module.exports = __webpack_public_path__ + "img/logo-factry.a1509ba7.jpg";